'use client';

import { Celebration } from '@depop/web-thrift-ui/Illustrations/Celebration';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { CalloutBanner } from '@/components/CalloutBanner';
import { SupportedLocation } from '@/modules/location/constants';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { useSellNowHref } from '@/modules/signup/hooks/useSellNowHref';

type Props = {
  variant: 'loggedIn' | 'loggedOut';
};

export function NoSellingFeesBanner({ variant }: Props) {
  const t = useTranslations('common');
  const { href } = useSellNowHref();
  const { location } = useCurrentLocation();

  if (location !== SupportedLocation.AU) {
    return null;
  }

  return (
    <CalloutBanner
      illustration={
        <Celebration
          alt={t('NoSellingFeesBanner.IllustrationAlt')}
          size="xSmall"
        />
      }
      className={clsx({
        [styles['noSellingFeesBanner--additionalMargin']]:
          variant === 'loggedOut',
      })}
      title={t('NoSellingFeesBanner.Title')}
      body={t('NoSellingFeesBanner.Body')}
      cta={{ label: t('NoSellingFeesBanner.Cta'), href }}
    />
  );
}
